import { z } from "zod";
import { ADDRESS, ALTERNATE_LOGIN_ID, COMMUNITY, EMAIL_ID_1, FIRST_NAME, LAST_NAME, MOBILE_NO, OWNERSHIP_TYPE, PROPERTY, USER_ID, USERS,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  EMAIL_ID_2,
  END_DATE,
  LANDLINE_NO,
  OCCUPANCY_TYPE,
  PO_BOX,
  START_DATE,
  STATE,
  USERNAME,
  ZIPCODE,
  CORRESPONDENCE_ADDRESS,
  USER_TYPE,
  OWNERSHIP_SHARE,
  MULTI_CORRESPOND,
  PRIMARY_USER,
  ORGANIZATION_NAME,
  CUSTOM_ADDRESS,
 } from "./consts";

export const schema = z.object({
  [COMMUNITY]: z.string().optional(),
  [PROPERTY]: z.string().min(1, "This field is required"),
  [OWNERSHIP_TYPE]: z.string().min(1, "This field is required"),
  [CORRESPONDENCE_ADDRESS]: z.string().optional(),
  [MULTI_CORRESPOND]: z.boolean().optional(),
  [ORGANIZATION_NAME]: z.string().optional(),
  [CUSTOM_ADDRESS]: z.any().optional(),
  [USERS]: 
    z.object({
      [USER_TYPE]: z.string().optional(),
      [USER_ID]: z.string().optional(),
      [OWNERSHIP_SHARE]: z.string().optional(),
      [ALTERNATE_LOGIN_ID]: z.string().min(4, "Please enter Alternate Login ID."),
      [FIRST_NAME]: z.string().min(2, "Please enter First Name."),
      [LAST_NAME]: z.string().min(2, "Please enter Last Name."),
      [MOBILE_NO]: z.string().min(10, "Please enter Mobile Number."),
      [EMAIL_ID_1]: z
        .string()
        .min(1, "Please enter Contact Email.")
        .email("This is not a valid email."),
      [ADDRESS]: z.object({
        [ADDRESS_1]: z.string().min(1, "Please enter Address 1."),
        [ADDRESS_2]: z.string().optional(),
        [ZIPCODE]: z
          .string()
          .min(1, "Please enter Zipcode.")
          .regex(
            /^[0-9]{5}-[0-9]{4}$/,
            "Enter ZIP code in XXXXX-XXXX format."
          ),
        [STATE]: z.string().min(1, "Please enter State."),
        [CITY]: z.string().min(1, "Please enter City."),
        [PO_BOX]: z.string().min(1, "Please enter P.O. Box."),
      }),
      [OCCUPANCY_TYPE]: z.string().min(1, "Please enter Occupancy Type."),
      [PRIMARY_USER]: z.boolean().optional(),
    
      // Optional Fields
      [LANDLINE_NO]: z.string().optional(),
      [EMAIL_ID_2]: z
        .string()
        .email("This is not a valid email.")
        .optional()
        .or(z.literal("")),
    
      [START_DATE]: z
        .union([z.string(), z.date()])
        .refine((val) => !isNaN(Date.parse(val.toString())), {
          message: "Invalid date format.",
        }),
      [END_DATE]: z
        .union([z.string(), z.date()])
        .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
          message: "Invalid date format.",
        })
        .optional(),
      [USERNAME]: z.string().min(4, "Please enter User ID."),
    }).array()
});

export type formValues = z.infer<typeof schema>;
